export default "__VITE_ASSET__D1_MtBzL__"